module.exports = __webpack_public_path__ + "img/group-invitation-code-me.1f97fd0a.png";